// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.js-components-css-FileModal-module__loadModal select{width:250px;height:300px;font-size:14px}`, "",{"version":3,"sources":["webpack://./js/components/css/FileModal.module.scss"],"names":[],"mappings":"AAAA,sDACI,WAAA,CACA,YAAA,CACA,cAAA","sourcesContent":[".loadModal select {\n    width: 250px;\n    height: 300px;\n    font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
export var loadModal = `js-components-css-FileModal-module__loadModal`;
export default ___CSS_LOADER_EXPORT___;
